import tinycolor from 'tinycolor2';

export const alpha = (color: string, a: number) => tinycolor(color).setAlpha(a).toRgbString();
